/**
 * 日付ユーティリティ（タイムゾーン安全）
 *
 * toISOString() は UTC を返すため、JST 00:00〜08:59 で前日になる。
 * このモジュールの関数は常にローカル時刻（JST）ベースで日付を返す。
 */

/**
 * ローカル日付を YYYY-MM-DD 形式で取得する
 *
 * new Date().toISOString().slice(0,10) の安全な代替。
 * JST 早朝でも正しい日付を返す。
 *
 * @param dt 対象日時（デフォルト: 現在時刻）
 */
export const getLocalDate = (dt: Date = new Date()): string => {
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, '0');
  const d = String(dt.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

/**
 * ローカル月を YYYY-MM 形式で取得する
 *
 * @param dt 対象日時（デフォルト: 現在時刻）
 */
export const getLocalYearMonth = (dt: Date = new Date()): string => {
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}`;
};

/**
 * 月初日を YYYY-MM-DD 形式で取得する
 *
 * @param dt 対象日時（デフォルト: 現在時刻）
 */
export const getLocalFirstOfMonth = (dt: Date = new Date()): string => {
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}-01`;
};

/**
 * 営業日を算出する（カットオフ時刻考慮）
 *
 * カットオフ時刻（デフォルト 05:00）より前は前日の営業日として扱う。
 * 例: 2026-04-03 03:00 → 営業日は 2026-04-02
 *
 * @param dt 対象日時（デフォルト: 現在時刻）
 * @param cutoffTime カットオフ時刻 HH:MM 形式（デフォルト: '05:00'）
 */
export const getBusinessDate = (dt: Date = new Date(), cutoffTime: string = '05:00'): string => {
  const [h, m] = cutoffTime.split(':').map(Number);
  const cutoffMinutes = h * 60 + m;
  const shifted = new Date(dt.getTime() - cutoffMinutes * 60 * 1000);
  return getLocalDate(shifted);
};
